import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import store from './../store'

import SignIn from "@/views/SignIn.vue"
import SheetList from "@/views/teacher/SheetList.vue"
import SheetEdit from "@/views/teacher/SheetEdit.vue"
import FieldEdit from "@/views/teacher/FieldEdit.vue"
import PositionEdit from "@/views/teacher/PositionEdit.vue"
import SheetUpload from "@/views/teacher/SheetUpload.vue"
import SaitenList from "@/views/teacher/SaitenList.vue"
import SaitenInput from "@/views/teacher/SaitenInput.vue"
import SaitenInputScoreStamp from "@/views/teacher/SaitenInputScoreStamp.vue"
import SaitenResultUpload from "@/views/teacher/SaitenResultUpload.vue"
import SumupScoreAverageList from "@/views/teacher/SumupScoreAverageList.vue"
import SumupScoreDistributionList from "@/views/teacher/SumupScoreDistributionList.vue"
import SumupMajorNoScoreRateList from "@/views/teacher/SumupMajorNoScoreRateList.vue"
import SumupQuestionScoreRateList from "@/views/teacher/SumupQuestionScoreRateList.vue"

import SumupList from "@/views/teacher/SumupList.vue"

import ResultList from "@/views/teacher/ResultList.vue"
import ResultStudentList from "@/views/teacher/ResultStudentList.vue"
import ResultDistributionList from "@/views/teacher/ResultDistributionList.vue"
import ResultStudentTwenty from "@/views/teacher/ResultStudentTwenty.vue"
import ResultStudentVarious from "@/views/teacher/ResultStudentVarious.vue"
import ResultStudentImageList from "@/views/teacher/ResultStudentImageList.vue";

import TeacherList from "@/views/teacher/TeacherList.vue";
import TeacherExcelUpload from "@/views/teacher/TeacherExcelUpload.vue";
import StudentList from "@/views/teacher/StudentList.vue";
import StudentExcelUpload from "@/views/teacher/StudentExcelUpload.vue";

import VariousResultDownload from "@/views/teacher/VariousResultDownload.vue"

import ResearchIdList from "@/views/teacher/ResearchIdList.vue"
import ResearchIdExcelUpload from "@/views/teacher/ResearchIdExcelUpload.vue"

import StreamingUrlEdit from "@/views/teacher/StreamingUrlEdit.vue"
import StreamingView from "@/views/teacher/StreamingView.vue"
import StreamingLogList from "@/views/teacher/StreamingLogList.vue"

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  { path: "/", name: "SignIn", component: SignIn },
  { path: "/teacher_site/sheet_list", name: "SheetList", component: SheetList },
  { path: "/teacher_site/sheet_edit", name: "SheetEdit", component: SheetEdit },
  { path: "/teacher_site/field_edit/:sheet_id", name: "FieldEdit", component: FieldEdit },
  { path: "/teacher_site/position_edit/:sheet_id", name: "PositionEdit", component: PositionEdit },
  { path: "/teacher_site/sheet_upload/:sheet_id", name: "SheetUpload", component: SheetUpload },
  { path: "/teacher_site/saiten_list/:sheet_id", name: "SaitenList", component: SaitenList },
  { path: "/teacher_site/saiten_input/:sheet_id/:sheet_field_id", name: "SaitenInput", component: SaitenInput },
  { path: "/teacher_site/saiten_input_score_stamp/:sheet_id/:sheet_field_id", name: "SaitenInputScoreStamp", component: SaitenInputScoreStamp },
  { path: "/teacher_site/saiten_result_upload/:sheet_id", name: "SaitenResultUpload", component: SaitenResultUpload },
  { path: "/teacher_site/sumup_score_average_list/:sheet_group_key/:subject_id", name: "SumupScoreAverageList", component: SumupScoreAverageList },
  { path: "/teacher_site/sumup_score_distribution_list/:sheet_group_key/:subject_id", name: "SumupScoreDistributionList", component: SumupScoreDistributionList },
  { path: "/teacher_site/sumup_major_no_score_rate_list/:sheet_group_key/:subject_id", name: "SumupMajorNoScoreRateList", component: SumupMajorNoScoreRateList },
  { path: "/teacher_site/sumup_question_score_rate_list/:sheet_group_key/:subject_id", name: "SumupQuestionScoreRateList", component: SumupQuestionScoreRateList },

  { path: "/teacher_site/sumup_list", name: "SumupList", component: SumupList },

  { path: "/teacher_site/result_list", name: "ResultList", component: ResultList },
  { path: "/teacher_site/result_student_list/:sheet_group_key/:room_id", name: "ResultStudentList", component: ResultStudentList },
  { path: "/teacher_site/result_distribution_list/:sheet_group_key/:room_id", name: "ResultDistributionList", component: ResultDistributionList },
  { path: "/teacher_site/result_student_twenty", name: "ResultStudentTwenty", component: ResultStudentTwenty },
  { path: "/teacher_site/result_student_various", name: "ResultStudentVarious", component: ResultStudentVarious },

  { path: "/teacher_site/teacher_list", name: "TeacherList", component: TeacherList },
  { path: "/teacher_site/teacher_excel_upload", name: "TeacherExcelUpload", component: TeacherExcelUpload },
  { path: "/teacher_site/student_list", name: "StudentList", component: StudentList },
  { path: "/teacher_site/student_excel_upload", name: "StudentExcelUpload", component: StudentExcelUpload },
  { path: "/teacher_site/result_student_image_list/:nendo", name: "ResultStudentImageList", component: ResultStudentImageList },

  { path: "/student_site/result_student_twenty", name: "ResultStudentTwenty", component: ResultStudentTwenty },
  { path: "/student_site/result_student_various", name: "ResultStudentVarious", component: ResultStudentVarious },
  { path: "/student_site/result_distribution_list/:sheet_group_key/:room_id", name: "ResultDistributionList", component: ResultDistributionList },
  { path: "/student_site/result_student_image_list/:nendo", name: "ResultStudentImageList", component: ResultStudentImageList },

  { path: "/teacher_site/various_result_download", name: "VariousResultDownload", component: VariousResultDownload },
  { path: "/teacher_site/research_id_list", name: "ResearchIdList", component: ResearchIdList },
  { path: "/teacher_site/research_id_excel_upload", name: "ResearchIdExcelUpload", component: ResearchIdExcelUpload },

  { path: "/teacher_site/streaming_url_edit", name: "StreamingUrlEdit", component: StreamingUrlEdit },
  { path: "/teacher_site/streaming_view/:grade_id", name: "StreamingView", component: StreamingView },
  { path: "/student_site/streaming_view/:grade_id", name: "StreamingView", component: StreamingView },
  { path: "/teacher_site/streaming_log_list", name: "StreamingLogList", component: StreamingLogList },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
